<template>
  <div id="departments">
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input clearable size="small" :placeholder="$t('message.placeholder.input')" @clear="searchCriterias" @keyup.enter.native="searchCriterias" v-model="form.name" class="input-with-select" style="margin:0 20px 0 0">
            <el-button slot="append" icon="el-icon-search" @click="searchCriterias"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="success" size="small" icon="el-icon-circle-plus-outline"  @click="addForm">{{$t('message.button.add')}}</el-button>
        </el-col>
      </el-row>

      <!-- <el-form ref="form" :model="form" label-width="65px" style="overflow: hidden;">
        <el-form-item :label= "$t('message.table.name')" style="width: 20%;margin-top: 20px;float: left;">
          <el-input v-model="form.name" size="small" clearable></el-input>
        </el-form-item>
        <el-button @click="searchCriterias" type="primary" style="margin-top: 24px;margin-left: 30px;" size="small" icon="el-icon-search">{{$t('message.button.search')}}
        </el-button>
        <el-button type="success" size="small" icon="el-icon-plus" @click="addForm">{{$t('message.button.add')}}</el-button>
      </el-form> -->
      <div style="margin-top:20px">
        <vxe-grid v-bind="gridOptions" @cell-dblclick="dbClick" :row-style="{height:'56px'}">
          <template v-slot:operate="{ row }">
            <el-button @click="removeRowEvent(row)" type="text" icon="el-icon-delete">{{$t('message.button.delete')}}</el-button>
            <!-- <vxe-button icon="el-icon-delete" :title="$t('message.button.delete')" circle @click="removeRowEvent(row)"></vxe-button> -->
            <!-- <vxe-button icon="el-icon-view" :title="$t('message.button.check')" circle @click="Info(row)"></vxe-button> -->
          </template>
        </vxe-grid>
      </div>
    </el-card >
    <el-dialog height="600px" width="1000px" :close-on-click-modal="false" :title="editPageTitle" :visible.sync="criteriaAddEditShow" @closed="dialogClose">
      <SearchQuery v-if="criteriaAddEditShow" objType='criteria' :criteriaId = 'displayCriteriaId' @changeCriteria="dialogCloseAfterSave" class="search-content">
        
      </SearchQuery>
    </el-dialog>
  </div>

</template>

<style scoped>
  .search-content {
    margin: 25px 10px;
  }
</style>

<script>
  import axios from "axios";
  import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
  export default {
    name: 'criteria',
    data() {
      return {
        displayCriteriaId: "", //编辑的criteria id

        editPageTitle:"",
        search:'',

        nameRule: [
          {required: true, message: this.$t('message.warning.name')}
        ],
        input_width: {}, //宽度
        createForm: {
          name: "",
          classId:"",
          description: "",
          enabled: "2",
        },
        criteriaAddEditShow: false, //添加表格
        form: {
          name: "",
        },
        gridOptions: {
          keepSource: true,
          resizable: true,
          // border: true,
          stripe: true,
          highlightHoverRow: true,
          highlightCurrentRow: true,
          showHeaderOverflow: true,
          showOverflow: true,
          rowId: 'id',
          height: "680",
          size: "small",
          
          classId:[],
          columns: [
          //   {
          //   sortable: true,
          //   field: 'id',
          //   title: 'ID'
          // }, 
          {
            sortable: true,
            field: 'name',
            title: this.$t('message.table.name')
          }, {
            sortable: true,
            field: 'description',
            title: this.$t('message.table.des')
          }, 
          {
            sortable: true,
            field: 'clsName',
            title: this.$t('message.table.type')
          }
         
          , {
            title: this.$t('message.table.actions'),
            width: 120,
            slots: {
              default: 'operate'
            }
          }
          
          ],
          data: [],
          editConfig: {
            mode: 'row',
            showIcon: false,
            showStatus: true,
          },
          sortConfig: {
            trigger: 'cell'
          },
        },
      }
    },
    components: {
      SearchQuery,
    },
    mounted() {},
    methods: {
      getSearch(res) {
        
      },
      dialogCloseAfterSave() {
        this.displayCriteriaId = "";
        this.criteriaAddEditShow = false;
        // console.log("getList");
        this.getList();
      },

      dialogClose() {
        this.displayCriteriaId = "";
        this.criteriaAddEditShow = false;
        // this.$destroy('SearchQuery');
      },
      dbClick(row){
        console.log(row);
        console.log(row.row.id);
        this.type="criteria";
        this.displayCriteriaId = row.row.id;
        this.criteriaAddEditShow = true;
      },

      searchCriterias() {
        var val = this.form.name;
        var vm = this;
        axios.get('/pmdm/admin/criteria/searchSeeks?name='+val)
          .then(function (res) {
            //console.log(res);
            vm.gridOptions.data = res.data.object.seekList;
            console.log();
          })
          .catch(function (error) {
            //console.log(error);
          });
      },

      addForm() {
        this.criteriaAddEditShow = true;

      },
      getList() {
        console.log("getList");
        this.input_width = this.Global.input_width_small;
        var vm = this;
        axios.get('/pmdm/admin/criteria/getSeekList')
          .then(function (res) {
            console.log(res);
            vm.gridOptions.data = res.data.object.seekList;
            console.log(res);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      removeRowEvent(row) {
        //console.log(row);
        this.$confirm(this.$t('message.confirm.deleteList'), this.$t('message.tips.tip'), {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning'
        }).then(() => {
          var vm = this;
          axios.post('/pmdm/admin/criteria/deleteSeekById?seekId=' + row.id)
            .then(function (res) {
              if (res.data.code == 200) {
                console.log(res);
                vm.$message({
                  type: 'success',
                  message: res.data.message,
                });
                vm.getList();
              };
            })
            .catch(function (error) {
              //console.log(error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('message.tips.deleteCancel')
          });
        });
      },
    },

    created() {
      this.getList();
    }
  };
</script>